
<template>
  <div
    class="v-input flex flex-wrap flex-direction-column"
    :class="[className , {' pt-4' : label,} ]">
    <v-tooltip
      bottom
      content-class="">
      <template #activator="{ on }">
        <v-text-field
          :id="id_name"
          ref="input"
          v-model="model_text"
          append-icon=""
          :autofocus="autofocus"
          class="text-field pa-0 "
          color="var(--black-color)"
          :counter="counter "
          data-qa="text-field"
          dense
          :disabled="disabled"
          :error-messages="typeof error_messages == 'string' ? error_messages : ''"
          :hide-details="hide_details"
          :hint="hint"
          :maxlength="maxlength"
          :persistent-placeholder="!!placeholder"
          :placeholder="placeholder"
          :prefix="prefix"
          :readonly="readonly"
          rounded
          :rules=" all_rules "
          :type="type"
          :value="value"
          v-on=" title ? on : ''"
          @blur="blur"
          @change="$emit('change_text', model_text)"
          @click="ev => $emit('click', ev)"
          @click:clear="$emit('change_text', model_text )"
          @focus="focus"
          @input="input"
          @keydown.enter.prevent="$emit('enter' )">
          <template
            v-if="prepimage"
            #prepend-inner>
            <sIcon
              class="mr-1 mt-2"
              type="search"/>
          </template>
          <template #label>
            <span
              v-if="!!label"
              class=" h8-text black--text">
              <span
                v-if="required"
                class="h5-headline secondary__red--text">*</span> {{ label }}
            </span>
          </template>
          <template #message="{ message }">
            {{ message }}
          </template>
        </v-text-field>
      </template>
      <span v-if="title">{{ title }}</span>
    </v-tooltip>
  </div>
</template>
<script>
/* eslint-disable vue/prop-name-casing */

import { textRulesMixin } from 'mixins'
import { debounce } from 'toolkit/utils/util'

export default {
  name: 'textField',
  mixins: [textRulesMixin],
  props: {
    placeholder: String,
    prepimage: Boolean,
    not_clearable: Boolean,
    model: [String, Number],
    className: {
      type: String,
      default: () => ''
    },
    label: [String, Number],
    value: String,
    rules: {
      type: Array,
      default: () => []
    },
    prefix: String,
    show_details: Boolean,
    id_name: String,
    error_messages: [String, Boolean],
    readonly: Boolean,
    type: String,
    autofocus: Boolean,
    disabled: Boolean,
    required: Boolean,
    maxlength: [String, Number],
    max_length: [String, Number],
    counter: [String, Number],
    debounce: Boolean,
    title: String,
  },
  computed: {
    model_text: {
      get() {
        return this.model
      },
      set(value) {
        this.$emit('update:model', value)
      }
    },
    all_rules() {
      if ( this.counter || this.max_length ) {
        // eslint-disable-next-line vue/no-mutating-props, vue/no-side-effects-in-computed-properties
        this.rules.push(this.counterRule)
      }
      return this.rules
    }
  },
  methods: {
    input(text, ev) {
      this.$emit('immediately', text, ev)
      if (this.debounce ) {
        this.debouncedAction()
      } else {
        this.$emit('action', text)
      }
    },
    click_clear(ev) {
      this.model_text = ''
      this.$emit('click_clear', ev)
      this.$nextTick(() => {

        this.input(this.model_text , ev)
      })
    },
    debouncedAction: debounce(function () {
      this.$emit('action', this.model_text )
    }, 250),
  }
}
</script>
<style lang="scss">
.v-input .text-field {
  width: 100%;
}

.text-field {
  font-size: 14px;
  display: flex;
  align-items: center;

  &.error--text {
    .v-messages {
      color: var(--v-secondary__red-base) !important;
    }
  }
}
</style>
<style lang="scss">
.text-field {
  position: relative;

  .v-label {
    transform: translateY(-30px) scale(1);
  }

  .v-input__slot {
    height: 40px;
    padding: 0 12px !important;
    background: var(--white-color);
    border-radius: 31px;
    border: 2px solid var(--v-main__green-base);
  }
  &.v-input--is-readonly .v-input__slot{
    border-color: var(--main__green_locked);
    background: var(--secondary__green_locked);
  }
  &.error--text .v-input__slot{
    border: 2px solid var(--v-secondary__red-base);
  }

  .v-input__append-inner .v-input__icon > .v-icon {
    margin: 0 !important;
  }
}
.sFormItem.is-error .text-field .v-input__slot{

    border: 2px solid var(--v-secondary__red-base);
}
</style>
